<template>
  <div class="usage">
    <div class="usage-head">
      <span class="usage-label">{{ label }}</span>
      <strong class="usage-text">{{ text }}</strong>
    </div>
    <div v-if="percent !== null" class="usage-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="Math.round(shown)" :aria-label="label">
      <div class="usage-fill" :class="tone" :style="{width: `${shown}%`}"></div>
    </div>
    <span v-if="hint" class="usage-hint">{{ hint }}</span>
  </div>
</template>

<script>
/**
 * Jauge d'utilisation : libellé, valeur lisible et barre colorée (tone : ok, warning ou critical).
 * Sans pourcentage (aucune limite connue), seule la valeur est affichée.
 */
export default {
  name: 'UsageBar',
  props: {
    label: {type: String, required: true},
    text: {type: String, required: true},
    percent: {type: Number, default: null},
    tone: {type: String, default: 'ok'},
    hint: {type: String, default: ''},
  },
  computed: {
    shown() {
      return Math.min(100, Math.max(0, this.percent ?? 0));
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.usage
  display flex
  flex-direction column
  gap 5px
  min-width 0

.usage-head
  display flex
  flex-wrap wrap
  justify-content space-between
  align-items baseline
  gap 2px 12px
  font-size 13px

.usage-label
  min-width 0
  overflow-wrap anywhere
  color CTRL_TEXT_MUTED

.usage-text
  flex none
  white-space nowrap
  color THEME_COLOR_PRIMARY

.usage-track
  height 8px
  overflow hidden
  background #eef1f6
  border-radius 8px

.usage-fill
  height 100%
  border-radius 8px
  transition width .3s

  &.ok
    background #3fbd63

  &.warning
    background #ef9400

  &.critical
    background #ea4e2c

.usage-hint
  font-size 12px
  color CTRL_TEXT_MUTED
</style>
